import React from 'react';
import styled from 'styled-components';
import { device } from "../device";
import { FullWidthImage } from "../imageComponents";

const CardContainer = styled.div`
    margin-bottom: ${({last}) => 
        (last === 'xs' && '0') || 
        '32px'
    };
    @media ${device.sm} {
        margin-bottom: ${({last}) => 
            (last === 'xs' && '0') || 
            (last === 'sm' && '0') || 
            '48px'
        };
    }
`;
const ImageContainer = styled.div`
    margin-bottom: 16px;
`;
const H4 = styled.h4`
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    @media ${device.lg} {
        font-size: 18px;
    }
`;
const Text = styled.div`
    font-size: 14px;
`;

function CardComponent(props) {
    return (
        <CardContainer last={props.last}>
            <ImageContainer>
                <FullWidthImage src={props.src} alt="" />
            </ImageContainer>
            <H4>{props.title}</H4>
            <Text>{props.text}</Text>
        </CardContainer>
    )
}

export default CardComponent